module.exports = __webpack_public_path__ + "img/set-rules.6b933454.svg";